const refresh = () => {
  const wkt_key = localStorage.getItem("wkt_key");
  if (wkt_key) {
    fetch("https://api.waku-tan.jp/users/v1/shopify/refresh", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "",
        "x-authorization": `Bearer ${wkt_key}`,
      },
    }).then((response) => {
      if (response.status !== 200) {
        localStorage.setItem("wkt_key", "");
        window.location.href = "/account/logout";
      }
    });
  }
};

refresh();
